class SearchPage {
  private selectedFilters: { name: string; value: string; label: string }[] = [];
  private scopeChangePending = false;

  constructor() {
    this._init();
  }

  private _init() {
    this._setInitialDropdownValuesFromURL();
    this._updateSelectedFilters();
    this._renderSelectedFilters();
    this._filterOptionReset();
    this._setupTabs();
    this._adjustTabMenu();
    this._setupFilterDropdowns();
    this._setupScopeDropdowns();
    this._handleSorting();
    this._setupEscCloseForDetails();
    this._setupSearchFormSubmit();
    this._setupHeadingExpandLinks();
  }

  private _filterOptionReset() {
    const resetButton = document.querySelector(".reset") as HTMLElement;
    resetButton?.addEventListener("click", () => this._resetAllFilters(true));
  }

private _resetAllFilters(reload = false) {
  const selects = document.querySelectorAll(".search-page__filter-select") as NodeListOf<HTMLSelectElement>;
  selects.forEach(select => select.value = "");

  const url = new URL(window.location.href);
  selects.forEach(select => {
    const nameAttr = select.name || select.getAttribute("data-name");
    if (nameAttr) nameAttr.split(",").forEach(key => url.searchParams.delete(key));
  });

  this._updateSelectedFilters();

  // Dölj valda filter innan reload
  const container = document.querySelector(".search-result__section-container") as HTMLElement | null;
  if (container) {
    const activeFilters = container.querySelector(".search-page__active-filters") as HTMLElement | null;
    if (activeFilters) activeFilters.style.display = "none"; // ✅ måste vara HTMLElement
  }

  if (reload) {
    // Ladda om sidan med uppdaterad URL
    window.location.href = url.toString();
  } else {
    this._renderSelectedFilters();
  }
}


  private _setupTabs() {
    const tabContainers = document.querySelectorAll('.info-switcher');
    tabContainers.forEach(container => {
      const tabs = Array.from(container.querySelectorAll<HTMLLIElement>('.tab-menu__item'));
      const panels = Array.from(container.querySelectorAll<HTMLElement>('.info-switcher__content'));

      tabs.forEach(tab => {
        tab.setAttribute('tabindex', tab.classList.contains('active') ? '0' : '-1');
        tab.setAttribute('aria-selected', tab.classList.contains('active') ? 'true' : 'false');


      });

      panels.forEach(panel => {
        panel.setAttribute('aria-hidden', !panel.classList.contains('active') ? 'true' : 'false');
        if (panel.classList.contains('active')) panel.setAttribute('tabindex', '0');
        else panel.removeAttribute('tabindex');
      });

      const activeTab = tabs.find(tab => tab.classList.contains('active'));
      (tabs.find(tab => tab.classList.contains('active') ? tab.classList.add('tab-menu__item--active') : tab.classList.remove('tab-menu__item--active')));
      if (!activeTab && tabs.length > 0) this._activateTab(tabs[0], tabs, panels);

      tabs.forEach(tab => {

        tab.addEventListener('click', e => { e.preventDefault(); this._handleTabClick(tab, tabs, panels); });
        tab.addEventListener('keydown', e => {
          switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown': e.preventDefault(); this._focusNextTab(tab, tabs); break;
            case 'ArrowLeft':
            case 'ArrowUp': e.preventDefault(); this._focusPreviousTab(tab, tabs); break;
            case 'Home': e.preventDefault(); tabs[0].focus(); break;
            case 'End': e.preventDefault(); tabs[tabs.length - 1].focus(); break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              this._handleTabClick(tab, tabs, panels); // aktiverar tabben
              break;
          }
        });
      });
    });
  }

  private _activateTab(tab: HTMLElement, tabs: HTMLElement[], panels: HTMLElement[]) {
    tabs.forEach(t => {
      t.classList.remove('active');
      t.classList.remove('tab-menu__item--active');
      const svg = t.querySelector('svg');
      if (svg) {
        svg.classList.remove('tab-menu__icon--active');
      }
      t.setAttribute('aria-selected', 'false'); t.setAttribute('tabindex', '-1');
    });
    panels.forEach(p => { p.classList.remove('active'); p.setAttribute('aria-hidden', 'true'); p.removeAttribute('tabindex'); });

    tab.classList.add('active');
    tab.classList.add('tab-menu__item--active');
    const svg = tab.querySelector('svg');
    if (svg) {
      svg.classList.add('tab-menu__icon--active');
    }
    tab.setAttribute('aria-selected', 'true'); tab.setAttribute('tabindex', '0');
    const targetId = tab.dataset.target?.replace('#', '');
    const targetPanel = panels.find(p => p.id === targetId);
    if (targetPanel) { targetPanel.classList.add('active'); targetPanel.setAttribute('aria-hidden', 'false'); targetPanel.setAttribute('tabindex', '0'); }
    tab.focus({ preventScroll: true });
  }

  private _handleTabClick(tab: HTMLElement, tabs: HTMLElement[], panels: HTMLElement[]) {
    const scrollY = window.scrollY;
    this._activateTab(tab, tabs, panels);
    if (window.innerWidth > 768) window.scrollTo({ top: scrollY });
    tab.focus({ preventScroll: true });
  }

  private _focusNextTab(currentTab: HTMLElement, tabs: HTMLElement[]) { const index = tabs.indexOf(currentTab); tabs[(index + 1) % tabs.length].focus(); }
  private _focusPreviousTab(currentTab: HTMLElement, tabs: HTMLElement[]) { const index = tabs.indexOf(currentTab); tabs[(index - 1 + tabs.length) % tabs.length].focus(); }

  private _setupHeadingExpandLinks() {
    document.querySelectorAll<HTMLAnchorElement>('a.expand-link[data-target-id]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const targetId = link.getAttribute('data-target-id');
        if (!targetId) return;
        const details = document.getElementById(targetId) as HTMLDetailsElement | null;
        if (details) details.open = !details.open;
      });
    });
  }

  private _setupEscCloseForDetails() {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        const details = document.activeElement?.closest('details[open]') as HTMLDetailsElement | null;
        if (details) { details.open = false; const summary = details.querySelector('summary') as HTMLElement; summary?.focus(); }
      }
    });
  }

  private _setupFilterDropdowns() {
    document.querySelectorAll(".search-page__filter-select").forEach(dropdown => {
      if (dropdown.id === "scope-select") return; // scope hanteras separat

      dropdown.addEventListener("change", e => {
        const target = e.target as HTMLSelectElement;
        const nameAttr = target.name || target.getAttribute("data-name");
        const names = nameAttr ? nameAttr.split(",") : [];

        const url = new URL(window.location.href);
        names.forEach(n => {
          if (target.value) url.searchParams.set(n, target.value);
          else url.searchParams.delete(n);
        }
        );
        window.location.href = url.toString(); // reload
      });
    });
  }

  private _setupScopeDropdowns() {
    const scopeDropdown = document.querySelector<HTMLSelectElement>("#scope-select");
    if (!scopeDropdown) return;

    scopeDropdown.addEventListener("change", () => {
      this.scopeChangePending = true;
      scopeDropdown.classList.add("pending-scope-change");
    });
  }
  private _adjustTabMenu() {
    const menu = document.querySelector<HTMLUListElement>("#tabMenu");
    const moreItem = document.querySelector<HTMLLIElement>("#moreMenuItem");
    const moreDropdown = document.querySelector<HTMLUListElement>("#moreMenuDropdown");
    const moreDetails = moreItem?.querySelector<HTMLDetailsElement>("details");
    const moreArrow = moreItem?.querySelector<HTMLElement>(".tab-menu__arrow");
    const moreTitle = moreItem?.querySelector<HTMLElement>(".tab-menu__title");

    if (!menu || !moreItem || !moreDropdown || !moreDetails) return;

    const moveTabsToMore = () => {
      // Flytta tillbaka allt först
      Array.from(moreDropdown.children).forEach(item => menu.insertBefore(item, moreItem));
      moreDropdown.innerHTML = "";

      let allItems = Array.from(
        menu.querySelectorAll<HTMLLIElement>(".tab-menu__item:not(.tab-menu__item--more)")
      );

      allItems.forEach(item => { item.classList.remove("tab-menu__item--moved"); });

      const activeItem = allItems.find(item => item.hasAttribute("data-active"));
      const parentWidth = menu.parentElement?.clientWidth || menu.clientWidth;

      if (window.innerWidth <= 768) {
        // 🔹 MOBIL: Visa max 5 flikar, flytta resten till "Fler..."-dropdown
        // Bevara ordningen, men activeItem ska alltid vara synlig och inte flyttas till "Fler..."
        if (allItems.length <= 5) {
          moreItem.style.display = "none";
        } else {
          const visibleItems = allItems.slice(0, 5);
          let overflow = allItems.filter(item => !visibleItems.includes(item));

          // Om activeItem inte finns bland de första 5, byt ut den 5:e till activeItem
          if (activeItem && !visibleItems.includes(activeItem)) {
            const replaced = visibleItems[4];
            visibleItems[4] = activeItem;
            overflow = overflow.filter(item => item !== activeItem);
            overflow.unshift(replaced);
            allItems = visibleItems;
          }

          overflow.forEach(item => {
            item.classList.add("tab-menu__item--moved");
            moreDropdown.appendChild(item);
            item.style.display = "flex";
          });
          moreItem.style.display = "";
        }
        return;
      }

      // DESKTOP: Kolla först om allt får plats utan "Fler..."-dropdown
      moreItem.style.display = "none";

      if (menu.scrollWidth <= parentWidth) {
        // Allt får plats, ingen dropdown behövs
        return;
      }

      // Säkerhetmekanism för att undvika oändliga loopar
      let safeCounter = 0;

      // Flytta flikar, en i taget tills allt får plats (bevara ordningen, activeItem ska alltid vara synlig)
      while (allItems.length > 0 && menu.scrollWidth > parentWidth && safeCounter < 20) {
        safeCounter++;
        let itemToMove: HTMLLIElement | null = null;
        for (let i = allItems.length - 1; i >= 0; i--) {
          if (allItems[i] !== activeItem) {
            itemToMove = allItems[i];
            break;
          }
        }

        if (itemToMove) {
          itemToMove.classList.add("tab-menu__item--moved");
          moreDropdown.prepend(itemToMove);
          allItems = allItems.filter(i => i !== itemToMove);
        }

        // Visa dropdown och kolla att menyn får plats
        moreItem.style.display = "";

        if (menu.scrollWidth <= parentWidth) {
          break;
        }
      }

      if (moreDropdown.children.length === 0) {
        moreItem.style.display = "none";
      }
    };

    // Kör initialt
    moveTabsToMore();

    // Hantera resize
    let resizeTimeout: number;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(moveTabsToMore, 200); // Vänta 200 ms efter sista resize-eventet innan man kör funktionen
    });

    //  Stäng "Fler..."-dropdown om man klickar utanför
    document.addEventListener("click", e => {
      const target = e.target as Node;
      if (moreDetails.open && target && !moreDetails.contains(target)) {
        moreDetails.open = false;
      }
    });

    moreDetails.addEventListener("toggle", () => {
      if (window.innerWidth <= 768 && moreTitle != null) {
        moreTitle.textContent = moreDetails.open ? "Stäng Fler…" : "Fler…";
      }

      moreDropdown.classList.toggle("tab-menu__dropdown--open", moreDetails.open);
      moreArrow?.classList.toggle("tab-menu__arrow--open", moreDetails.open);
      moreDetails.classList.toggle("tab-menu__details--open", moreDetails.open);

    });
  }
  private _setupSearchFormSubmit() {
    const searchForm = document.querySelector(".search-page__form") as HTMLFormElement;
    if (!searchForm) return;

    searchForm.addEventListener("submit", this._onSubmit.bind(this));
  }
  private _onSubmit(e: Event) {
    e.preventDefault();
    const url = new URL(window.location.href);
    const searchInput = document.querySelector<HTMLInputElement>("#search");
    const previousValue = new URL(window.location.href).searchParams.get("q") || "";
    const keysToDelete = Array.from(url.searchParams.keys());
    
    // Spara scope och hsaid före rensning (dessa är systemparametrar, inte UI-state)
    const savedScope = url.searchParams.get("s");
    const savedHsaid = url.searchParams.get("hsaids");
    
    if ((searchInput?.value !== previousValue ||
      this.selectedFilters == null || this.selectedFilters.length === 0) || this.scopeChangePending) {

      keysToDelete.forEach(key => {
        // Radera INTE scope och hsaid - dessa är systemparametrar
        if (key !== "s" && key !== "hsaids") {
          url.searchParams.delete(key);
        }
      });
    }
    
    this._applyScopeToURL(url);
    this._applyFiltersToURL(url);
    this._applySearchQueryToURL(url); //  Lägg till sökfältet här

    // Nollställ scopeChangePending efter submit
    this.scopeChangePending = false;
    const scopeDropdown = document.querySelector<HTMLSelectElement>("#scope-select");
    if (scopeDropdown) {
      scopeDropdown.classList.remove("pending-scope-change");
    }

    window.location.href = url.toString();
  }
  private _applySearchQueryToURL(url: URL) {
    const searchInput = document.querySelector<HTMLInputElement>("#search");
    if (!searchInput) return;

    if (searchInput.value) {
      url.searchParams.set("q", searchInput.value);
    } else {
      url.searchParams.delete("q");
    }
  }

  private _applyScopeToURL(url: URL) {
    const scopeSelect = document.querySelector<HTMLSelectElement>("#scope-select");

    if (!scopeSelect) return;

    const option = scopeSelect.selectedOptions[0];

    url.searchParams.set("s", scopeSelect.value);

    option.selected = true;

    // hsaids hör till scope aldrig UI-state
    url.searchParams.delete("hsaids");

    const hsaid = option?.dataset.hsaid;
    if (hsaid) {
      url.searchParams.set("hsaids", hsaid);
    }

  }
  private _applyFiltersToURL(url: URL) {
    document.querySelectorAll<HTMLSelectElement>(".search-page__filter-select")
      .forEach(select => {
        const name = select.name;
        if (!name) return;
        const option = Array.from(select.options).find(o => o.value === select.value || o.text === select.value);
        if (select.value) {
          url.searchParams.set(name, select.value);
        }
      });
  }
 
  private _initFiltersFromURL(url: URL) {
    document.querySelectorAll<HTMLSelectElement>(".search-page__filter-select")
      .forEach(select => {
        const name = select.name;
        if (!name) return;

        const value = url.searchParams.get(name);
        if (!value) return;

        const option = Array.from(select.options).find(o => o.value === value || o.text === value);
        if (option) {
          option.selected = true;
          option.value = value;
        }
      });
  }

  private _setInitialDropdownValuesFromURL() {
    const url = new URL(window.location.href);

    this._initScopeFromURL(url);
    this._initFiltersFromURL(url);
  }

private _initScopeFromURL(url: URL) {

  const scopeSelect = document.querySelector<HTMLSelectElement>("#scope-select");
  const currentScope = document.querySelector<HTMLInputElement>('input[name="s"]');
  const currentHsaId = document.querySelector<HTMLInputElement>('input[name="HsaIdCollection"]');

  const scopeParam = url.searchParams.get("s");
  const hsaidParam = url.searchParams.get("hsaids");

  // FALL 1 — scopeSelect finns
  if (scopeSelect && scopeSelect.options.length > 0) {

    const options = Array.from(scopeSelect.options);

    const scopeExists = scopeParam
      ? options.some(o => o.value === scopeParam)
      : false;

    const selectedOption = scopeExists
      ? options.find(o => o.value === scopeParam)!
      : options[0];

    scopeSelect.value = selectedOption.value;
    selectedOption.selected = true;

    const newScope = selectedOption.value;
    const newHsaid = selectedOption.dataset.hsaid;

    // Endast reload om scopeParam är angiven men inte giltig (felaktig data som måste fixas)
    if (scopeParam && !scopeExists) {
      url.searchParams.set("s", newScope);
      if (newHsaid) {
        url.searchParams.set("hsaids", newHsaid);
      } else {
        url.searchParams.delete("hsaids");
      }
      window.location.href = url.toString();
    }
    // Annars: scope och hsaid läggs till automatiskt nästa gång sökknappen klickas (_applyScopeToURL)
    return;
  }

  // FALL 2 — ingen select → hidden inputs
  const newScope = currentScope?.value;
  const newHsaid = currentHsaId?.value;

  let reloadNeeded = false;

  if (newScope && scopeParam !== newScope) {
    url.searchParams.set("s", newScope);
    reloadNeeded = true;
  }

  if (newHsaid && hsaidParam !== newHsaid) {
    url.searchParams.set("hsaids", newHsaid);
    reloadNeeded = true;
  }

  if (!newHsaid && hsaidParam) {
    url.searchParams.delete("hsaids");
    reloadNeeded = true;
  }

  if (reloadNeeded) {
    window.location.href = url.toString();
  }
}


  private _updateSelectedFilters() {
    this.selectedFilters = [];
    const urlParams = new URLSearchParams(window.location.search);
    document.querySelectorAll(".search-page__filter-select").forEach(select => {
      const selectEl = select as HTMLSelectElement; // Typa om elementet
      const name = selectEl.name || selectEl.getAttribute("data-name") || "";
      const selectedOption = Array.from(selectEl.options).find(option => option.selected);
      const val = urlParams.get(name);

      if (selectedOption && (selectedOption.value || val)) {
        this.selectedFilters.push({
          name,
          value: selectedOption.value,
          label: selectedOption.textContent?.trim() || selectedOption.value
        });
      }
    });

  }

  private _renderSelectedFilters() {
    const container = document.querySelector(".search-result__section-container") as HTMLElement;
    if (!container) return;


    if (!this.scopeChangePending) {
      container.querySelector(".search-page__active-filters")?.remove();
    }

    if (this.selectedFilters.length === 0) return;

    const wrapper = document.createElement("div");
    wrapper.className = "search-page__active-filters active-filters active-filters--visible-mobile";
    wrapper.setAttribute("role", "region"); wrapper.setAttribute("aria-label", "Valda filter");

    const ul = document.createElement("ul"); ul.className = "active-filters__list";

    this.selectedFilters.forEach(filter => {
      const li = document.createElement("li");
      li.innerHTML = `<div class="active-filters__wrapper"><span class="active-filters__title">${filter.label}</span>
        <button class="active-filters__icon" data-filter-name="${filter.name}" data-filter-value="${filter.value}" aria-label="Ta bort valt filter:${filter.value}">
          <span class="sr-only">Ta bort valt filter: ${filter.label}</span>
           <svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.2426 3.06284C10.6037 2.70181 10.6037 2.11844 10.2426 1.75741C9.88161 1.39638 9.29825 1.39638 8.93721 1.75741L6 4.69462L3.06279
               1.75741C2.70175 1.39638 2.11839 1.39638 1.75736 1.75741C1.39633 2.11844 1.39633 2.70181 1.75736 3.06284L4.69457 6.00005L1.75736 8.93726C1.39633
                9.2983 1.39633 9.88166 1.75736 10.2427C2.11839 10.6037 2.70175 10.6037 3.06279 10.2427L6 7.30548L8.93721 10.2427C9.29825 10.6037 9.88161
                 10.6037 10.2426 10.2427C10.6037 9.88166 10.6037 9.2983 10.2426 8.93726L7.30543 6.00005L10.2426 3.06284Z"
                  fill="#005B89"/>
           </svg>
        </button></div>`;
      li.querySelector("button")!.addEventListener("click", e => { e.preventDefault(); this._removeFilter(filter.name, filter.value); });
      ul.appendChild(li);
    });

    const liClear = document.createElement("li");
    liClear.className = "clear-filters";
    const resetLink = document.createElement("button");
    resetLink.type = "reset"; resetLink.className = "search-page__reset link-focus";
    resetLink.setAttribute("aria-label", "Rensa alla filter: " + this.selectedFilters.length);
    resetLink.textContent = `Rensa filter (${this.selectedFilters.length})`;
    resetLink.addEventListener("click", e => { e.preventDefault(); this._resetAllFilters(true); }); // reload
    liClear.appendChild(resetLink);
    ul.appendChild(liClear);

    wrapper.appendChild(ul); container.appendChild(wrapper);
  }

  private _removeFilter(name: string, value: string) {
    const selects = document.querySelectorAll(`.search-page__filter-select[name='${name}']`) as NodeListOf<HTMLSelectElement>;
    selects.forEach(select => { if (select.value === value) select.value = ""; });

    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    window.location.href = url.toString();
  }

  private _handleSorting() {
    const sortButtons = document.querySelectorAll(".search-page__linkbutton");
    const sortDropdown = document.getElementById("sort-dropdown") as HTMLSelectElement;
    const url = new URL(window.location.href);

    let sortValue = url.searchParams.get("sort");
    if (!sortValue && sortButtons.length > 0) {
      sortValue = sortButtons[0].getAttribute("data-sort-value") || "";
      url.searchParams.set("sort", sortValue);
      window.history.replaceState({ path: url.href }, '', url.href);
    }

    if (sortDropdown && sortValue) sortDropdown.value = sortValue;

    const updateButtonStates = (activeSort: string) => {
      sortButtons.forEach(btn => { const btnSort = btn.getAttribute("data-sort-value"); btn.setAttribute("aria-pressed", btnSort === activeSort ? "true" : "false"); });
    };
    if (sortValue) updateButtonStates(sortValue);

    sortButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const sortVal = btn.getAttribute("data-sort-value") || "";
        const u = new URL(window.location.href);
        u.searchParams.set("sort", sortVal);
        window.location.href = u.toString();
      });
    });

    sortDropdown?.addEventListener("change", () => {
      const u = new URL(window.location.href);
      u.searchParams.set("sort", sortDropdown.value);
      window.location.href = u.toString();
    });
  }

}

(function () {
  const searchPage = document.querySelector(".search-page__form");
  if (searchPage) new SearchPage();
})();
